
<template>
  <div class="home-container">
    <auth v-if="showAuth" :mode="authMode" @close="showAuth = false" />
    <ProfileOverlay v-if="showProfile" @close="closeProfile" />
    <About :visible="showAbout" @close="closeAbout" />
    <app-navbar
      :showAbout="showAbout"
      :inProfile="showProfile"
      @close-about="closeAbout"
      @open-about="openAbout"
      @open-login="openLogin"
      @open-signup="openSignup"
      @open-profile="openProfile"
      @back-to-live="backToLive"
    ></app-navbar>
    <router-view :showAbout="showAbout" @close-about="closeAbout" @open-signup="openSignup" />
    <app-footer
      @close-about="closeAbout"
      @open-about="openAbout"
      @open-profile="openProfile"
      @open-login="openLogin"
      @open-signup="openSignup"
      :showAbout="showAbout"
    ></app-footer>
  </div>
</template>

<script>
import AppNavbar from "./components/navbar";
import AppFooter from "./components/footer";
import Auth from "./components/auth.vue";
import ProfileOverlay from "./components/profile.vue";
import About from "./components/about.vue";

export default {
  name: "App",
  components: {
    AppNavbar,
    AppFooter,
    Auth,
    ProfileOverlay,
    About
  },
  metaInfo: {
    title: "Nuance Radio",
    meta: [
      {
        property: "og:title",
        content: "Nuance Radio",
      },
    ],
  },
  data() {
    return {
      showAbout: false,
      showAuth: false,
      authMode: 'login',
      showProfile: false
    };
  },
  methods: {
    openAbout() {
      this.showAbout = true;
    },
    closeAbout() {
      this.showAbout = false;
    },
    openLogin() {
      this.authMode = 'login';
      this.showAuth = true;
    },
    openSignup() {
      this.authMode = 'register';
      this.showAuth = true;
    },
    openProfile() {
      this.showProfile = true;
    },
    closeProfile() {
      this.showProfile = false;
    },
    backToLive() {
      this.showProfile = false;
      this.showAbout = false;
    }
  },
};
</script>

<style scoped>
.home-container {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
</style>